<template>
  <div
    :style="{
      backgroundImage:
        'url(' + (activeInfo.actSignInImg && activeInfo.actSignInImg) + ')',
      backgroundSize: 'cover',
    }"
    class="bg"
  >
    <van-nav-bar :title="dataForm.actName + '在线提问'">
      <template #right>
        <img src="../assets/img/timg.jpg" alt class="avaterImg" />
      </template>
    </van-nav-bar>
    <van-popup
      v-model="showSuccess"
      style="width: 85%; padding: 10px; border-radius: 5px"
    >
      <div class="infoMsg">
        <img src="../assets/img/success.png" alt="" />
        <p>提交成功！</p>
        <van-row>
          <van-col span="8" offset="2">
            <van-button round block type="info" @click="closePage"
              >关闭</van-button
            >
          </van-col>
          <van-col span="8" offset="4">
            <van-button round block type="info" @click="againQuestion">
              再次提问
            </van-button>
          </van-col>
        </van-row>
      </div>
    </van-popup>

    <van-form @submit="onSubmit">
      <div class="formBg">
        <van-field
          v-model="content"
          name="content"
          rows="5"
          autosize
          type="textarea"
          placeholder="请输入内容"
          :rules="[{ required: true, message: '内容不能为空' }]"
        />
      </div>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: '',
      actId: '',
      dataForm: {},
      showSuccess: false,
      activeInfo: {},
    }
  },
  mounted() {
    var url = window.location.href
    var cs = url.split('?')[1] //?后面的参数字符串
    var cs_arr = cs.split('&') //将参数字符串分割为包含多个参数的数组
    var cs = {} //声明一个容器
    for (var i = 0; i < cs_arr.length; i++) {
      //遍历数组
      cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }
    this.actId = Number(cs.actId)
    this.getActiveInfo()
    this.getInfo()
  },
  methods: {
    getActiveInfo() {
      this.$http({
        url: `/act/activity/info/${this.actId}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.activeInfo = data.data
        }
      })
    },
    // 关闭页面
    closePage() {
      WeixinJSBridge.call('closeWindow')
    },
    againQuestion() {
      location.reload()
    },
    getInfo() {
      this.$http({
        url: `/act/activity/info/${this.actId}`,
        method: 'get',
        params: {},
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm = data.data
        }
      })
    },
    onSubmit(values) {
      let data = {}
      data.actId = this.actId
      data.queSource = 1
      if (this.content.length > 50) {
        this.$toast({
          message: '提问内容不能超过50个字',
          position: 'bottom',
          duration: 1500,
        })
        return
      }
      data.queContent = this.content
      this.$http({
        url: '/act/questions/save',
        method: 'post',
        data: data,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.content = ''
          this.showSuccess = true
        } else {
          this.$toast(data.msg)
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.formBg {
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
  margin: 10px;
}
.bg {
  min-height: 100vh;
}
.infoMsg {
  text-align: center;
  padding-top: 50px;
  p {
    padding: 10px;
    margin: 0 20px;
    border-radius: 10px;
    text-align: center;
    margin-top: 20px;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
.avaterImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
/deep/.van-form {
  margin: 30px 10px 0;
}
/deep/.van-cell {
  border: 1px solid #ccc;
}
/deep/.van-cell::after {
  border-bottom: none;
}
</style>